import axios from '../../config/axiosConfig';
import {
    GET_BANK_DETAILS, CREATE_BANK_DETAIL, BANK_DETAIL_REQUEST,
    DELETE_BANK_DETAIL, UPDATE_BANK_DETAIL, BANK_DETAIL_REQUEST_FAILURE,
    GET_BANK_DETAILS_PAGE, BANK_DETAIL_REQUEST_SUCCESS
} from '../types';

export const getBankDetails = () => {
    return async (dispatch, getState) => {
        const { auth } = getState();
        try {
            return axios.get('/bank-detail/getAll',{ params: { userId: auth?.superUser?.id }}).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_BANK_DETAILS, payload: response.data });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: BANK_DETAIL_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: BANK_DETAIL_REQUEST_FAILURE, error: error.message });
        }
    };
};

export const getBankDetailById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_DETAIL_REQUEST });
      return axios.get(`/bank-detail/get/${id}`).then((response) => {
        dispatch({ type: BANK_DETAIL_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_DETAIL_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_DETAIL_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getBankDetailByName = (bankName) => {
  return async (dispatch, getState) => {
    try {
    //   dispatch({ type: BANK_DETAIL_REQUEST });
      return axios.get(`/bank-detail/get-bank-detail-by-name`, { params: { bankName: bankName }}).then((response) => {
        // dispatch({ type: BANK_DETAIL_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        // dispatch({ type: BANK_DETAIL_REQUEST_SUCCESS, error: error.message });  
      });
    } catch (error) {
      console.error(error);
    //   dispatch({ type: BANK_DETAIL_REQUEST_SUCCESS, error: error.message });
    }
  };
};

export const getBankDetailWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_DETAIL_REQUEST });
      const { auth } = getState();
      let params = {
        page, limit, include, addTotal, search: searchStr, searchCols, where,
      };
      return axios.get("/bank-detail/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_BANK_DETAILS_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_DETAIL_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_DETAIL_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createBankDetail = (bankDetailData) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: BANK_DETAIL_REQUEST });
            const { auth, bankDetail } = getState();
            return axios.post("/bank-detail/add", bankDetailData, { params: { userId: auth?.superUser?.id } }).then(async (response) => {
                if (response.data) {
                    dispatch({ type: CREATE_BANK_DETAIL, payload: response.data });
                    // dispatch(getStates());
                    await dispatch(getBankDetailWithPagination(
                        bankDetail.page || 1,           // current page
                        bankDetail.pageSize || 10,      // current page size
                        undefined,                  // include
                        bankDetail.search || '',        // current search
                        undefined,                  // searchCols
                        bankDetail.where || {},         // current filters
                        true                        // addTotal
                    ));
                } else {
                    dispatch({
                        type: BANK_DETAIL_REQUEST_FAILURE,
                        error: "Bank Detail create failed.",
                    });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: BANK_DETAIL_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: BANK_DETAIL_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const updateBankDetail = (id, bankDetailData) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: BANK_DETAIL_REQUEST });
            const { auth, bankDetail } = getState();
            return axios.put('/bank-detail/update', { id, bankDetailData }, { params: { userId: auth.superUser?.id }}).then(async (response) => {
                if (response.data) {
                    dispatch({ type: UPDATE_BANK_DETAIL, payload: { id, data: response.data } });
                    await dispatch(getBankDetailWithPagination(
                        bankDetail.page || 1,           // current page
                        bankDetail.pageSize || 10,      // current page size
                        undefined,                  // include
                        bankDetail.search || '',        // current search
                        undefined,                  // searchCols
                        bankDetail.where || {},         // current filters
                        true                        // addTotal
                    ));
                } else {
                    dispatch({ type: BANK_DETAIL_REQUEST_FAILURE, error: 'Bank Detail update failed.' });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: BANK_DETAIL_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: BANK_DETAIL_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};



export const deleteBankDetail = (id) => {
    return async (dispatch, getState) => {
        try {
            const { bankDetail } = getState();

            dispatch({ type: BANK_DETAIL_REQUEST });
            return axios.delete(`/bank-detail/delete/${id}`).then(async (response) => {
                if (response.data) {
                    dispatch({ type: DELETE_BANK_DETAIL, id: id });
                    await dispatch(getBankDetailWithPagination(
                        bankDetail.page || 1,           // current page
                        bankDetail.pageSize || 10,      // current page size
                        undefined,                  // include
                        bankDetail.search || '',        // current search
                        undefined,                  // searchCols
                        bankDetail.where || {},         // current filters
                        true                        // addTotal
                    ));
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: BANK_DETAIL_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: BANK_DETAIL_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};